import React, { useState } from "react";
import { Link } from "react-router-dom";

function Footer() {
  const [isMobile] = useState(window.innerWidth <= 568);

  return (
    <footer className="mt-auto">
      {/* Top Links */}
      <div className="flex flex-wrap items-center justify-center border-t border-gray-300">
        <Link
          to="/feedback"
          className="text-blue-600 px-2.5 py-1.5 pb-1 text-sm hover:underline"
        >
          Feedback
        </Link>

        <Link
          to="/privacy"
          className="text-blue-600 px-2.5 py-1.5 pb-1 text-sm hover:underline"
        >
          Privacy
        </Link>

        <Link
          to="/terms-and-condition"
          className="text-blue-600 px-2.5 py-1.5 pb-1 text-sm hover:underline"
        >
          {isMobile ? "T&C" : "Terms & Conditions"}
        </Link>
      </div>

      {/* Copyright */}
      <div className="text-center mb-0 sm:mb-1">
        <p className="mt-0 sm:mt-1 text-sm font-medium text-gray-700">
          Copyright © {new Date().getFullYear()}, All Rights Reserved
        </p>
      </div>
    </footer>
  );
}

export default Footer;
